import * as React from "react"
import PropTypes from "prop-types"
import { all, any } from "ramda"
import { clearDirtyForm, setDirtyForm } from "./forms.utils"

/**
 * Transform plain text new line char to html BR
 *
 * @param  {string}  input  Plain text
 *
 * @return {string}
 */
export const nlToBR = (input) =>
  input
    .split("\n")
    .map((item) => `${item}<br/>`)
    .join("")

/**
 * { item_description }
 */
export const listShape = {
  items: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,

  creatingItem: PropTypes.object.isRequired,

  updatingIds: PropTypes.array.isRequired,
  deletingIds: PropTypes.array.isRequired,
  lastLoadAt: PropTypes.string,

  isLoading: PropTypes.bool.isRequired,
  isReloading: PropTypes.bool.isRequired,
  isCreating: PropTypes.bool.isRequired,
}

// TODO: Add support for React.Fragment
export const isOfComponentType = (types) => (child) =>
  Array.isArray(child)
    ? all(isOfComponentType(types))(child)
    : any(
        (typesHasElm) =>
          child.type.prototype instanceof typesHasElm ||
          child.type === typesHasElm,
      )(types)

export const oneOfComponentType =
  ({ types, errorMessage }) =>
  (props) => {
    const validChildren = React.Children.toArray(props.children).filter(Boolean)
    if (validChildren.length === 0) {
      return null
    }

    if (
      all(
        (_) => _ === true,
        React.Children.map(validChildren, isOfComponentType(types)),
      )
    ) {
      return null
    }

    return new Error(errorMessage)
  }

export const usePrevious = (value) => {
  const ref = React.useRef()

  React.useEffect(() => {
    ref.current = value
  })

  return ref.current
}

export const useUnsavedChangesWarning = ({
  content,
  formName,
  isDirty,
  shouldAbortLeave,
  shouldSaveContent,
}) => {
  const prevIsDirty = usePrevious(isDirty)

  const handleBeforeUnload = function (event) {
    if (isDirty) {
      event.preventDefault()
    }
  }

  React.useEffect(() => {
    if (shouldAbortLeave) {
      setDirtyForm(formName, content, shouldSaveContent)
    }
  }, [content])

  React.useEffect(() => {
    if (!shouldAbortLeave) {
      return
    }

    if (prevIsDirty !== isDirty) {
      if (isDirty === true) {
        window.addEventListener("beforeunload", handleBeforeUnload)
      } else {
        clearDirtyForm(formName)
      }
      return () => {
        if (isDirty) {
          clearDirtyForm(formName)
        }
        window.removeEventListener("beforeunload", handleBeforeUnload)
      }
    }
  }, [isDirty])
}
